import _ from "lodash";
import { generateRandomNumber } from "./GenerateRandomId";

export const getThumbnailForVideo = async ({ url, videoSnapTime = 0 }) => {
  let imageUrl = "";
  try {
    imageUrl = await new Promise((resolve, reject) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (video) {
        let seekResolve;
        video.addEventListener("seeked", async function () {
          if (seekResolve) seekResolve();
        });

        const hasScheme = url.indexOf("://") >= 0;
        const hostName = "://" + window.location.host;
        const isdata = url.indexOf("data:") === 0;
        const isBlob = url.indexOf("blob:") === 0;
        const useCors =
          !isdata && !isBlob && hasScheme && url.indexOf(hostName) === -1;
        if (useCors) {
          video.crossOrigin = "";
          url = `${url}?_=${new Date().getTime()}`;
        }

        video.setAttribute("src", url);

        (async () => {
          // workaround chromium metadata bug (https://stackoverflow.com/q/38062864/993683)
          while (
            (video.duration === Infinity || isNaN(video.duration)) &&
            video.readyState < 2
          ) {
            await sleep(1000);
            video.currentTime = generateRandomNumber(0, 999999999, true);
          }
        })().catch(e => {});

        // video.setAttribute("autoplay", true);
        video.setAttribute("muted", true);
        video.setAttribute("playsinline", true);
        video.load();

        video.addEventListener("loadeddata", async function (event) {
          const { videoHeight, videoWidth } = _.get(event, "srcElement", {});
          canvas.width = videoWidth;
          canvas.height = videoHeight;

          video.currentTime = videoSnapTime;

          await new Promise(r => (seekResolve = r));

          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, videoWidth, videoHeight);
          ctx.drawImage(video, 0, 0, videoWidth, videoHeight);
          try {
            canvas.toBlob(blob => {
              let blobUrl = "";
              try {
                blobUrl = URL.createObjectURL(blob);
              } catch (e) {}
              // Remove video & canvas elements (no longer needed)
              video.src = ""; // setting to empty string stops video from loading
              video.remove();
              canvas.remove();
              resolve(blobUrl);
            }, "image/jpeg");
          } catch (error) {
            reject("Tainted Canvas Error");
          }
        });

        video.onerror = event => {
          reject("getThumbnailForVideo: Video Error");
        };
      } else {
        reject("getThumbnailForVideo: video dom not found");
      }
    });
  } catch (e) {
    console.error("getThumbnailForVideo: ", e);
  }

  return imageUrl;
};

export const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
